import { render, staticRenderFns } from "./ArticleChapter.vue?vue&type=template&id=117190dc&"
import script from "./ArticleChapter.vue?vue&type=script&lang=js&"
export * from "./ArticleChapter.vue?vue&type=script&lang=js&"
import style0 from "./ArticleChapter.vue?vue&type=style&index=0&id=117190dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports